export const ErrorTypes = {
    // The plan has no credits or quota left - offer an upgrade.
    CREDIT_LIMIT: 'CreditLimit',
    // Too many requests too fast - tell the user to wait, nothing is used up.
    // May carry retry_after (the keyword-import cooldown does, a precondition 429 does not);
    // CreditLimit never does. It only chooses the wording - never branch on it.
    RATE_LIMIT: 'RateLimit',
};
